import React from "react";
import A5Template from "./a5-template";

const SalesPrintA5English = React.forwardRef((props, ref) => {
    require("./scss/sales-print-a5.css");

    let templateData = {};
    if (props.data) templateData = props.data;

    return (
        <div ref={ref} style={{margin: 0}}>
            <A5Template templateData={templateData} doubleA5={false} lang={"EN"} />
        </div>
    )
})

export default SalesPrintA5English
